import { Component } from '@angular/core';

@Component({
  selector: 'app-health-safety',
  templateUrl: './health-safety.component.html',
  styleUrl: './health-safety.component.scss'
})
export class HealthSafetyComponent {

}
